import React, { useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ActionHandlerFunction, IActionHandlerTyped, UserProfile, UserListData } from "@preveil-api";
import { Account, isSameProfile, UserListActionTypes, UIManagerActionTypes, FilterStatesTypes } from "src/common";
import { UserList, UserBadges } from "src/components";
import { DateFilter } from ".";
import _ from "lodash";

type AllProps = {
    current_account: Account;
    is_loading: boolean;
    filter?: string;
    default_active?: FilterStatesTypes;
    className?: string;
    include_forever?: boolean;
    handleAction: ActionHandlerFunction;
}

function FiltersComponent(props: AllProps) {
    const { current_account, className, default_active, include_forever, handleAction } = props;
    const [users_filter, setUserFilters] = useState<UserProfile[]>([]);
    const user_list_ref = useRef<{ handlePageActions: ActionHandlerFunction }>();
    // Description: Handle selection of user add badge and update parents filters
    function handleUpdateUsers(action_obj: IActionHandlerTyped<UserListData>) {
        setUserFilters(action_obj.params.current_contacts);
        handleAction({ actionType: UIManagerActionTypes.UserFilter, params: action_obj.params.current_contacts });
    }

    // Description: Remove a badge from array
    function handleRemoveUserBadge(profile: UserProfile) {
        const new_filters = users_filter.slice();
        const index = _.findIndex(new_filters, (_profile: UserProfile) => isSameProfile(profile, _profile));
        index >= 0 && new_filters.splice(index, 1);
        setUserFilters(new_filters);
        !!user_list_ref.current &&
            user_list_ref.current.handlePageActions({ actionType: UserListActionTypes.RemoveProfile, params: profile });
    }

    return <Container fluid
        className={`list-filters ${!!className ? className : ""}`}>
        <Row>
            <Col lg={5} md={6} className="order-md-1 order-2 ">
                <b>Users:</b>
                <UserList
                    ref={user_list_ref}
                    placeholder="Filter by user..."
                    current_account={current_account}
                    hide_badges={true}
                    handleAction={handleUpdateUsers} />

            </Col>
            <Col lg={7} md={6} className="order-md-2 order-1 mb-md-0 mb-3">
                <b>Timeframe:</b>
                <DateFilter
                    default_value={null}
                    default_active={default_active}
                    include_forever={include_forever}
                    handleAction={handleAction} />
            </Col>
        </Row>
        <div className="user-badges">
            <UserBadges
                show_external_users={true}
                current_contacts={users_filter}
                handleAction={handleRemoveUserBadge} />
        </div>
    </Container>;
}

export default React.memo(FiltersComponent);